import React from "react";
import { IContract, IContractLimit } from "dataModels/contract";
import "views/contractView/styles/newElementFormStyles.css";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import {v4 as uuid} from "uuid";
import { Output } from "@ds/ds-snam/react";
import moment from "moment";
import { DATE_FORMAT } from "shared/constants";

interface IContractLimitsProps {
    contract: IContract
}
const ContractLimitsDisplay: React.FC<IContractLimitsProps> = (props): JSX.Element => {
    const { contract } = props;
    const { t } = useTranslation(['contract']);
    return (
        <>
            <p className="documentTableTitle--contract">
                {t('contract.contractForm.sections.review.contractLimits.title')}
            </p>
            <div className="box">
                <div style={{ margin: "8px 0 24px", padding: "8px 0" }}>
                    <Output
                        outputTitle={t('contract.contractForm.sections.dataInput.fields.18')}
                        outputText={contract.contractLimitDate != null
                            ? moment.unix(contract.contractLimitDate).format(DATE_FORMAT).replace(/\//g, '.')
                            : "-"}
                        style={{ marginBottom: "16px" }}
                    ></Output>
                </div>
                <div className="contractFormReview-file--table-header" style={{ fontWeight: "400",marginBottom:'16px' }}>
                    {/*Tipologie selezionate*/}
                    {t('contract.contractForm.sections.review.contractLimits.selectionTiming')} :&nbsp;
                    <span>{contract.limits.length ? contract.limits.map((contractLimit: IContractLimit) => {
                        return t('contract.contractForm.sections.dataInput.contractLimits.selectionTiming.' + contractLimit.type);
                    }).join(", ") : " -"}</span>
                </div>

                {_.orderBy(contract.limits, ['type'], ['asc']).map((limit: IContractLimit) => {
                    return (
                        <div className="boxContent" key={uuid()}>
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('contract.contractForm.sections.dataInput.contractLimits.fields.slot.' + limit.type)}
                                    outputText={limit.slot.toString()+""}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                {/*<p className="boxFieldLabel">
                                    {t('contract.contractForm.sections.dataInput.contractLimits.fields.slot.' + limit.type)}
                                </p>
                                <p className="boxFieldData">
                                    {limit.slot}
                                </p>*/}

                            </div>
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('contract.contractForm.sections.dataInput.contractLimits.fields.delta.' + limit.type)}
                                    outputText={limit.delta+"%"}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                {/*<p className="boxFieldLabel">
                                    
                                    {t('contract.contractForm.sections.dataInput.contractLimits.fields.delta.' + limit.type)}
                                </p>
                                <p className="boxFieldData">
                                    {limit.delta}%
                                </p>*/}

                            </div>
                        </div>
                    )
                })}

            </div>
        </>
    )
}
export default ContractLimitsDisplay